var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.137,
    height: 42.352,
    viewBox: "0 0 46.137 42.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(0 -21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M46.133,61.9l-.694-9.019a4.3,4.3,0,0,0-2.907-3.721V31.363a1.352,1.352,0,0,0-.794-1.231L21.824,21.121a1.352,1.352,0,0,0-1.114,0L.795,30.132a1.352,1.352,0,0,0,0,2.463l19.915,9.011a1.352,1.352,0,0,0,1.114,0l18.006-8.147v15.7a4.3,4.3,0,0,0-2.907,3.721L36.229,61.9a1.352,1.352,0,0,0,1.348,1.455h7.209A1.352,1.352,0,0,0,46.133,61.9Z",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M85.868,217.063A4.029,4.029,0,0,1,84.2,216.7L71,210.731v8.077a3.317,3.317,0,0,0,1.625,2.7,11.365,11.365,0,0,0,3.293,1.5,35.613,35.613,0,0,0,9.951,1.263,35.614,35.614,0,0,0,9.951-1.263,11.362,11.362,0,0,0,3.293-1.5,3.317,3.317,0,0,0,1.625-2.7v-8.077L87.54,216.7a4.027,4.027,0,0,1-1.672.361Z",
    transform: "translate(-64.602 -172.634)",
    fill: "#212968"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForStudent);
export default __webpack_public_path__ + "static/media/for-student.e6a415eb1b67409698b89306573b64df.svg";
export { ForwardRef as ReactComponent };